<div class="eportfolio-settings">
    {#if showError}
        <Banner type="warning" visible={true} text={terms.errorOccurredTryAgainLater} closable={true} close={terms.close} />
    {/if}

    <section class="section">
        <h2>{terms.availableDiscSpace}</h2>
        <div class="section-content">
            {settings.discSpaceUsedText}
        </div>
    </section>
    {#if canChangeUseBlogSetting}
        <section class="section">
            <h2>{terms.blog}</h2>
            <div class="section-content">
                <div class="section-description">{terms.blogDescription}</div>
                <div class="section-content">
                    <Checkbox bind:checked={unsavedSettings.useBlog} label={terms.showBlog} />
                </div>
            </div>
        </section>
    {/if}
    <section class="section">
        <h2>{terms.accessLevel}</h2>
        <div class="section-description">{terms.accessLevelDescription}</div>
        <div class="section-content">
            <AccessLevelList 
                accessLevels={accessLevels} 
                accessLevelType={unsavedSettings.accessLevelType} 
                password={unsavedSettings.password} 
                terms={terms} 
                on:change={onAccessLevelChange} />
        </div>
        <div class="sectionContent inherit-access-level-container">
            <Checkbox bind:checked={unsavedSettings.inheritAccessLevel} label={terms.inheritAccessSetting} small="true" />
            <div class="note">{terms.inheritAccessSettingDescription}</div>
        </div>
    </section>
    <section class="buttons">
        <Button text={terms.save} type="basic" htmlType="button" on:click={onSaveClick} disabled={saveInProgress} />
        <Button type="secondary" text={terms.cancel} htmlType="button" on:click={onCancelClick} disabled={saveInProgress} />
    </section>
</div>

<script>
    import { onMount, createEventDispatcher } from 'svelte';

    import Button from '@itslearning/prometheus/assets/inputs/Button/v1/Button.svelte';
    import Checkbox from '@itslearning/prometheus/assets/inputs/Checkbox/v1/Checkbox.svelte';
    import AccessLevelList from '../AccessLevelList/AccessLevelList.svelte';
    import Banner from '@itslearning/prometheus/assets/feedback/Banner/v1/Banner.svelte';
    import { put } from '@itslearning/atlas/network/fetch';
    import { copyEPortfolioSettings, createAntiForgeryHeader } from '../common';

    export let terms = {};
    export let canChangeUseBlogSetting = true;
    export let saveSettingsUrl = '';
    export let settings = {};
    export let accessLevels = {};
    export let antiForgeryHeaderSettings = {};
    export let unsavedSettings = {};
    export let showError = false;
    export let saveInProgress = false;

    const dispatch = createEventDispatcher();

    onMount(() => {
        unsavedSettings = copyEPortfolioSettings(settings);
    });

    function onSaveClick() {
        if (saveInProgress) {
            return;
        }

        saveInProgress = true;
        showError = false;
        
        put(saveSettingsUrl, preparePostData(), {
            headers: createAntiForgeryHeader(antiForgeryHeaderSettings)
        })
            .then((data) => {
                saveInProgress = false;
                dispatch('saveEPortfolioSettings', { settings: copyEPortfolioSettings(data) });
            })
            .catch(() => {
                saveInProgress = false;
                showError = true;
            });
    }

    function onCancelClick() {
        if (saveInProgress) {
            return;
        }

        dispatch('closeEPortfolioSettings', {});
    }

    function onAccessLevelChange(event) {
        const settings = unsavedSettings;

        settings.accessLevelType = event.detail.accessLevelType;

        if (event.detail.password !== undefined) {
            settings.password = event.detail.password;
        }

        unsavedSettings = settings;
    }

    function preparePostData() {
        const settings = unsavedSettings;

        const data = {
            EPortfolioId: settings.ePortfolioId,
            UseBlog: settings.useBlog,
            AccessLevel: settings.accessLevelType,
            InheritAccessLevel: settings.inheritAccessLevel,
            Password: settings.password
        };

        return data;
    }
</script>
